export function WebsiteHeader() {
    return (<header>
        <div>
            <h1>Poetry Hangman</h1>
        </div>
    </header>);
}

